import * as React from 'react';
import { Container } from '../Container';
import '../Chat/app.scss';
import AWS from 'aws-sdk';
import Button from '@material-ui/core/Button';
import * as Config from '../../config';

import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { S3Client, GetObjectCommand, PutObjectCommand } from "@aws-sdk/client-s3";

import { AuthContext } from '../../contexts/AuthContext';
import { DAClient } from '../../lib/DAClient';
import '../Chat/app.scss';
import './listaws.scss';
import Axios from 'axios';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Modal from 'react-bootstrap/Modal';
import { Header } from '../Header';
import { Footer } from '../Footer';
import en from '../../languages/en.json';
import es from '../../languages/es.json';
import { MessageContainer } from '../../Containers/MessageContainer';
import * as LangConfig from '../../languages/languages';
import * as InterviewRef from '../../languages/langconfig';

const da = new DAClient();


export const ListAWSUsers: React.FC = () => {
	const auth: any = React.useContext(AuthContext);
	let userCognitoGroups = auth.accessToken.payload['cognito:groups'];
	const [translations, setTranslations] = React.useState(auth['user']['attributes'].locale ? LangConfig.languages[auth['user']['attributes'].locale]['translations'] : LangConfig.languages['en']['translations']);
	const [selectedLng, setselectedLng] = React.useState(auth['user']['attributes'].locale ? auth['user']['attributes'].locale : 'en');
	const [users, setUsers] = React.useState([]);
	const [loading, setLoading] = React.useState(false);
	const [selectedUser, setSelectedUser] = React.useState(null);
	const [addUser, setAddUser] = React.useState(false);
	const [userData, setUserData] = React.useState(null);
	const [emailError, setemailError] = React.useState(null);
	const [active, setActive] = React.useState(0);
	const [adminUsers, setAdminUsers] = React.useState([]);
	const [superAdminUsers, setSuperAdminUsers] = React.useState([]);
	const [availInterviews, setAvailInterviews] = React.useState([]);
	const [allavailInterviews, setAllAvailInterviews] = React.useState([]);
	const [allInterviews, setAllInterviews] = React.useState([]);
	const [help, setHelp] = React.useState<any>(false); 
	const [fileObject, setFileObject] = React.useState({'name' : ''});
	const [photoObject, setPhotoObject] = React.useState({'name' : ''});
	const [addError, setAddError] = React.useState(null);

	const getUsers = async (applicationName, status = 'all') => {
		console.log(status);
		try {
			let allUsers = [];
			let AdminUsers;
			let SuperAdminUsers;
			let more = true;
			let paginationToken = '';

			AWS.config.update(Config.AWSConfigExport);
			const cognito = new AWS.CognitoIdentityServiceProvider();

			let app_pool_Id: any;
			if (applicationName == 'ATJ') {
				app_pool_Id = Config.AWS_userPoolId;
			} else {
				app_pool_Id = Config.AWS_LDV_userPoolId;
			}

			let params: any, gparams: any, sgparams: any;
			while (more) {
				if (paginationToken !== '') {
					params = {
						UserPoolId: app_pool_Id,
						PaginationToken: paginationToken
					}
				} else {
					params = {
						UserPoolId: app_pool_Id
					}
				}
				gparams = {
					GroupName: "admin",
					UserPoolId: app_pool_Id
				}
				sgparams = {
					GroupName: "Superadmin",
					UserPoolId: app_pool_Id
				}
				const rawUsers = await cognito.listUsers(params).promise();
				AdminUsers = await cognito.listUsersInGroup(gparams).promise();
				SuperAdminUsers = await cognito.listUsersInGroup(sgparams).promise();
				rawUsers.Users.map(function (result, index) {
					let verfied = result.Attributes.find((item, key) => { return (item.Name == "email_verified") });
					console.log((result.UserStatus != "CONFIRMED" && status == "inactive"),(status == "all") ,(result.UserStatus == "CONFIRMED" && status == "active"));
					if (result.Enabled && ((result.UserStatus != "CONFIRMED" && status == "inactive") || (status == "all") || (result.UserStatus == "CONFIRMED" && status == "active"))) {
						allUsers.push({
							"Email": result.Attributes.find((item, key) => { return (item.Name == "email") }).Value,
							"FirstName": result.Attributes.find((item, key) => { return (item.Name == "given_name") }) ? result.Attributes.find((item, key) => { return (item.Name == "given_name") }).Value : '',
							"LastName": result.Attributes.find((item, key) => { return (item.Name == "family_name") }) ? result.Attributes.find((item, key) => { return (item.Name == "family_name") }).Value : '',
							"language": result.Attributes.find((item, key) => { return (item.Name == "locale") }) ? result.Attributes.find((item, key) => { return (item.Name == "locale") }).Value : '',
							"phone": result.Attributes.find((item, key) => { return (item.Name == "phone_number") }) ? result.Attributes.find((item, key) => { return (item.Name == "phone_number") }).Value : '',
							"address": result.Attributes.find((item, key) => { return (item.Name == "address") }) ? result.Attributes.find((item, key) => { return (item.Name == "address") }).Value : '',
							"photo": result.Attributes.find((item, key) => { return (item.Name == "picture") }) ? result.Attributes.find((item, key) => { return (item.Name == "picture") }).Value : '',
							"fileMatter": result.Attributes.find((item, key) => { return (item.Name == "custom:fileMatter") }) ? result.Attributes.find((item, key) => { return (item.Name == "custom:fileMatter") }).Value : '',
							"lastLogin": result.Attributes.find((item, key) => { return (item.Name == "custom:lastLogin") }) ? result.Attributes.find((item, key) => { return (item.Name == "custom:lastLogin") }).Value : '',
							"IP": result.Attributes.find((item, key) => { return (item.Name == "custom:IP") }) ? result.Attributes.find((item, key) => { return (item.Name == "custom:IP") }).Value : '',
							"Browser": result.Attributes.find((item, key) => { return (item.Name == "custom:Browser") }) ? result.Attributes.find((item, key) => { return (item.Name == "custom:Browser") }).Value : '',
							"Username": result.Username,
							"Status": result.UserStatus,
							"Email Verified": verfied ? verfied.Value : null,
							"Created": new Date(result.UserCreateDate).toISOString().split('T')[0],
							"Last Modified": new Date(result.UserLastModifiedDate).toISOString().split('T')[0],
							"Self": auth.user.attributes.email !== result.Attributes.find((item, key) => { return (item.Name == "email") }).Value ? false : true
						});
					}
				});

				if (rawUsers.PaginationToken) {
					paginationToken = rawUsers.PaginationToken;
				} else {
					more = false;
				}

			}
			setUsers(allUsers);
			setSuperAdminUsers(SuperAdminUsers.Users);
			setAdminUsers(AdminUsers.Users);
			submittedInterviews(allUsers);
		} catch (e) {
			// console.log(e);
			setLoading(false);
		}
	};
	const listAvailInterviews = async () => {
		let AvailableInterviews: any = await da.listInterviews();
		AvailableInterviews = AvailableInterviews.filter((e) => {
			return e.metadata['required privileges'].indexOf(Config.appHost) != -1;
		})
		// sort in descending order by interview title
		AvailableInterviews.sort((a, b) => (a.title > b.title) ? -1 : ((b.title > a.title) ? 1 : 0));
		AvailableInterviews = AvailableInterviews.map(e => {
			if (InterviewRef.languagesconfigs[e.filename]) {
				let myArray = AvailableInterviews.filter(el => el.filename == InterviewRef.languagesconfigs[e.filename][selectedLng]);
				return myArray[0];
			}
			return e;
		});

		let result = [];
		for (var i = 0; i <= AvailableInterviews.length - 1; i++) {
			let inde = result.findIndex(el => el.filename == AvailableInterviews[i].filename);
			if (inde > -1) {
			}
			else {
				result.push(AvailableInterviews[i]);
			}
		}
		AvailableInterviews = result;

		setAllAvailInterviews(AvailableInterviews);
		let temp = [];
		AvailableInterviews.forEach((ele, index) => {
			if (window.innerWidth < 767) {
				if (index < 1) {
					temp.push(ele);
				}
			} else {
				if (index <= 1) {
					temp.push(ele);
				}
			}
		});
		setAvailInterviews(temp);
		setActive(0);
	}

	const nextInterview = () => {
		let current = active;
		let temp = [];
		if (window.innerWidth < 767) {
			allavailInterviews.forEach((ele, index) => {
				if (index > current && temp.length < 1) {
					temp.push(ele);
				}
			});
		} else {
			allavailInterviews.forEach((ele, index) => {
				if (index > current && temp.length <= 1) {
					temp.push(ele);
				}
			});
		}
		setActive(current + 1);
		setAvailInterviews(temp);
	}

	const backInterview = () => {
		let current = active;
		let temp = [];
		if (window.innerWidth < 767) {
			allavailInterviews.forEach((ele, index) => {
				if (index == current - 1 && temp.length < 1) {
					temp.push(ele);
				}
			});
		} else {
			allavailInterviews.forEach((ele, index) => {
				if (index <= current && index >= current - 1 && temp.length <= 1) {
					temp.push(ele);
				}
			});
		}

		setActive(current - 1);
		setAvailInterviews(temp);
	}

	const submittedInterviews = async (allUsers = []) => {
		let sess = await Axios.post(Config.API_BASE_URL + 'getAllDocAssembleUserData', {
			host: Config.appHost
		});
		// sort in descending order by interview title
		sess.data.DocAssembleData.sort((a, b) => (a.title > b.title) ? -1 : ((b.title > a.title) ? 1 : 0));
		setAllInterviews(sess.data.DocAssembleData);

		usersSortByLastActivity(sess.data.DocAssembleData, allUsers);
	}

	const checkFileNumber = (result) => {
		if (result && result.fileNumber) {
			let file = result.fileNumber.split("&nb&");
			if (file[0] && file[0] > 0) {
				return true;
			}
		}
		return false;
	}

	const downloadFile = async (fileNumber, title) => {
		let file = fileNumber.split("&nb&");
		for (let f of file) {
			await da.retrieveFile(f, title);
		}
	}

	const viewInterview = async (result) => {
		window.location.href = "/viewinterview?v=" + result._id;
	}


	React.useEffect(() => {
		setLoading(true);
		getUsers('ATJ');
		listAvailInterviews();
		// submittedInterviews();

	}, [auth]);

	const usersSortByLastActivity = async(allInterviews1 = [], users1 = []) => {
		let usersLastActivity = [];
		await users1.map(async function (result, index) {
			let userCompletedInterviews: any = await allInterviews1.filter(iData => {
				return iData.userId == result.Email;
			});
			let data:any;

			if(userCompletedInterviews.length != 0) {
				data = {'user': result, 'last_interview': userCompletedInterviews[0].createdAt};
			} else {
				data = {'user': result, 'last_interview': ''};
			}
			usersLastActivity.push(data);
		});
		usersLastActivity.sort((a, b) => (a.last_interview > b.last_interview) ? -1 : ((b.last_interview > a.last_interview) ? 1 : 0));
		console.log(usersLastActivity);

		let sortUsers:any = [];
		for(let s of usersLastActivity) {
			sortUsers.push(s.user);
		}
		console.log(sortUsers);
		setUsers(sortUsers);
		setLoading(false);
	}

	const usersFilterStatus = async(event, users1 = []) => {
		setLoading(true);
		getUsers('ATJ', event.target.value);
	}

	const renderVerifiedTooltip = (props) => {
		return (
			<Tooltip id="verified-tooltip" {...props}>
				{translations.Email_Verified}
			</Tooltip>
		);
	}

	const renderNotVerifiedTooltip = (props) => {
		return (
			<Tooltip id="not-verified-tooltip" {...props}>
				{translations.Email_Not_Verified}
			</Tooltip>
		);
	}

	const renderResetRequiredTooltip = (props) => {
		return (
			<Tooltip id="reset-required-tooltip" {...props}>
				{translations.Reset_Required}
			</Tooltip>
		);
	}

	const renderMakeAdminTooltip = (props) => {
		return (
			<Tooltip id="not-verified-tooltip" {...props}>
				{translations.Make_Admin}
			</Tooltip>
		);
	}

	const renderRemoveAdminTooltip = (props) => {
		return (
			<Tooltip id="not-verified-tooltip" {...props}>
				{translations.Remove_as_Admin}
			</Tooltip>
		);
	}

	const renderDeleteTooltip = (props) => {
		return (
			<Tooltip id="not-verified-tooltip" {...props}>
				{translations.Delete_User}
			</Tooltip>
		);
	}

	const renderEditTooltip = (props) => {
		return (
			<Tooltip id="not-verified-tooltip" {...props}>
				{translations.Edit_User}
			</Tooltip>
		);
	}

	const checkInAdmin = (user) => {
		let admin = adminUsers.filter(u => u.Username == user.Username);
		if (admin.length > 0) {
			return true;
		}
		return false;
	}

	const checkInSuperAdmin = (user) => {
		let admin = superAdminUsers.filter(u => u.Username == user.Username);
		if (admin.length > 0) {
			return true;
		}
		return false;
	}

	const getBadge = (user) => {
		let sadmin = superAdminUsers.filter(u => u.Username == user.Username);
		if (sadmin.length > 0) {
			return (<span className="badge badge-primary">{translations.SUPER_ADMIN}</span>);
		}
		let admin = adminUsers.filter(u => u.Username == user.Username);
		if (admin.length > 0) {
			return (<span className="badge badge-primary">{translations.ADMIN}</span>);
		}
		return null;
	}

	const createAdmin = async (user) => {
		let params = {
			"GroupName": "admin",
			"Username": user.Username,
			"UserPoolId": Config.AWS_userPoolId
		}
		setLoading(true);
		try {
			AWS.config.update(Config.AWSConfigExport);
			const cognito = new AWS.CognitoIdentityServiceProvider();
			await cognito.adminAddUserToGroup(params).promise();
			getUsers('ATJ');
			listAvailInterviews();
			// submittedInterviews();
		} catch (err) {
			setLoading(false);
		}
	}

	const removeAsAdmin = async (user) => {
		let params = {
			"GroupName": "admin",
			"Username": user.Username,
			"UserPoolId": Config.AWS_userPoolId
		}
		setLoading(true);
		try {
			AWS.config.update(Config.AWSConfigExport);
			const cognito = new AWS.CognitoIdentityServiceProvider();
			await cognito.adminRemoveUserFromGroup(params).promise();
			getUsers('ATJ');
			listAvailInterviews();
			// submittedInterviews();
		} catch (err) {
			setLoading(false);
		}
	}

	const disableUser = async (user) => {
		if (window.confirm(translations.user_delete_confirm)) {
			let params = {
				"Username": user.Username,
				"UserPoolId": Config.AWS_userPoolId
			}
			setLoading(true);
			try {
				AWS.config.update(Config.AWSConfigExport);
				const cognito = new AWS.CognitoIdentityServiceProvider();
				await cognito.adminDisableUser(params).promise();
				getUsers('ATJ');
				listAvailInterviews();
				// submittedInterviews();
			} catch (err) {
				setLoading(false);
			}
		}
	}

	const confirmUser = async (user) => {
		let params = {
			"Username": user.Username,
			"UserPoolId": Config.AWS_userPoolId
		}
		setLoading(true);
		try {
			AWS.config.update(Config.AWSConfigExport);
			const cognito = new AWS.CognitoIdentityServiceProvider();
			await cognito.adminConfirmSignUp(params).promise();

			let res = await Axios.post(Config.API_BASE_URL + 'sendMail', { from: 'no-reply@lawdroid.com', to: user.Email, subject: 'Account Confirmation', name: user.FirstName+' '+user.LastName, URL: Config.appHost+'.atjbot.org/login', content: "Your ATJBot account is activated by admin, please click on the link below to login:"});

			getUsers('ATJ');
			listAvailInterviews();
			// submittedInterviews();
		} catch (err) {
			setLoading(false);
		}
	}

	const resetInformUser = async (user) => {
		let params = {
			"Username": user.Username,
			"UserPoolId": Config.AWS_userPoolId
		}
		setLoading(true);
		try {
			let res = await Axios.post(Config.API_BASE_URL + 'sendMail', { from: 'no-reply@lawdroid.com', to: user.Email, subject: 'Reset Password Required', name: user.FirstName+' '+user.LastName, URL: Config.appHost+'.atjbot.org/forgot', content: "Your ATJBot account needs a password reset before you can login to the system, please click on the link below to reset your password:"});

			getUsers('ATJ');
			listAvailInterviews();
		} catch (err) {
			setLoading(false);
		}
	}


	const changeSelectedUser = (value, field) => {
		let user = Object.create(selectedUser);
		user[field] = value;
		setemailError(null);
		setSelectedUser(user);
	}

	const changeAddUser = (value, field) => {
		let user:any = userData == null ? {} : userData;
		user[field] = value;
		setemailError(null);
		setAddError(null);
		setUserData(user);
	}

	const completeInterview = (user) => {
		console.log(user);
		localStorage.setItem("userId", user.Email);
		localStorage.setItem("userDetails", JSON.stringify(user));
		window.location.href = "/availableInterviews";
	}

  	const uploadPhoto = async(file) => {
		AWS.config.update(Config.AWSConfigExport);
		
		var fileName = file.name.split(/[.]+/);
		delete fileName[fileName.length - 1];
		fileName = fileName.join("_");
		var fileExt = file.name.split(/[.]+/).pop();

		const params = ({
			Bucket: 'user-pool-upload-photo',
			Key: fileName + Date.now() + '.' + fileExt,
			Body: file
		})

		const client = new S3Client({
			region: 'us-east-1',
			credentials: {
					accessKeyId: "AKIAUU2LLKYXYHJSNERO",
					secretAccessKey: "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"
				}
		});
		const command = new PutObjectCommand(params);
		const url = await getSignedUrl(client, command, { expiresIn: 3600 });
		const response = await fetch(url, { method: "PUT", body: file });
		const imageURL = url.split('?')[0];
		return imageURL;
 	}

 	const saveUser = async () => {
 		let regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
		let eValid: any = users.filter(e => e.Email == userData.Email);
		if (eValid.length > 0) {
			if (eValid.length == 1 && eValid[0].Username !== userData.Username) {
				setemailError(translations.email_already_taken);
				return;
			} else if (eValid.length > 1) {
				setemailError(translations.email_already_taken);
				return;
			}
		}
		if (!regexEmail.test(userData.Email)) {
			setemailError(translations.enter_valid_mail);
			return;
		}
		setemailError(null);

		let photo = "";		
		if(photoObject.name != undefined && photoObject.name != '') {
			let imageUploaded = await uploadPhoto(photoObject);
			changeAddUser(imageUploaded, 'photo');
			photo = imageUploaded;
		}

 		let params = {
			"UserAttributes": [
				{
					"Name": "email",
					"Value": userData.Email
				},
				{
					"Name": "email_verified",
					"Value": "true"
				},
				{
					"Name": "given_name",
					"Value": userData.FirstName
				},
				{
					"Name": "family_name",
					"Value": ""
				},
				{
					"Name": "locale",
					"Value": userData.language ? userData.language : 'en'
				},
				{
					"Name": "phone_number",
					"Value": userData.phone
				},
				{
					"Name": "address",
					"Value": userData.address
				},
				{
					"Name": "picture",
					"Value": photo
				},
				{
					"Name": "custom:fileMatter",
					"Value": userData.fileMatter
				}
			],
			"Username": userData.Email,
			"UserPoolId": Config.AWS_userPoolId,
			"DesiredDeliveryMediums": ['EMAIL'],

		}
		setLoading(true);
		try {
			AWS.config.update(Config.AWSConfigExport);
			const cognito = new AWS.CognitoIdentityServiceProvider();
			await cognito.adminCreateUser(params).promise();
			
			setAddUser(false);
			setUserData(null);
			setAddError(null);

			getUsers('ATJ');
			listAvailInterviews();
			// submittedInterviews();
		} catch (err) {
			console.log(err);
			setAddError(err.message);
			setLoading(false);
		}
 	}

	const updateUser = async () => {
		let photo = selectedUser.photo;		
		if(fileObject.name != undefined && fileObject.name != '') {
			let imageUploaded = await uploadPhoto(fileObject);
			changeSelectedUser(imageUploaded, 'photo');
			photo = imageUploaded;
		}

		let regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
		let eValid: any = users.filter(e => e.Email == selectedUser.Email);
		if (eValid.length > 0) {
			if (eValid.length == 1 && eValid[0].Username !== selectedUser.Username) {
				setemailError(translations.email_already_taken);
				return;
			} else if (eValid.length > 1) {
				setemailError(translations.email_already_taken);
				return;
			}
		}
		if (!regexEmail.test(selectedUser.Email)) {
			setemailError(translations.enter_valid_mail);
			return;
		}
		setemailError(null);

		let params = {
			"UserAttributes": [
				{
					"Name": "email",
					"Value": selectedUser.Email
				},
				{
					"Name": "given_name",
					"Value": selectedUser.FirstName
				},
				{
					"Name": "family_name",
					"Value": selectedUser.LastName
				},
				{
					"Name": "locale",
					"Value": selectedUser.language 
				},
				{
					"Name": "phone_number",
					"Value": selectedUser.phone
				},
				{
					"Name": "address",
					"Value": selectedUser.address
				},
				{
					"Name": "picture",
					"Value": photo
				},
				{
					"Name": "custom:fileMatter",
					"Value": selectedUser.fileMatter
				}
			],
			"Username": selectedUser.Username,
			"UserPoolId": Config.AWS_userPoolId
		}
		/*let setPasswordParams = {
			"Passsword": selectedUser.password,
			"Permanent": true,
			"Username": selectedUser.Username,
			"UserPoolId": Config.AWS_userPoolId
		}*/
		setSelectedUser(null);
		setLoading(true);
		try {
			AWS.config.update(Config.AWSConfigExport);
			const cognito = new AWS.CognitoIdentityServiceProvider();
			await cognito.adminUpdateUserAttributes(params).promise();
			/*if(selectedUser.password) {
				await cognito.adminSetUserPassword(setPasswordParams).promise();
			}*/
			getUsers('ATJ');
			listAvailInterviews();
			// submittedInterviews();
		} catch (err) {
			setLoading(false);
		}
	}

	return (
		<MessageContainer
			render={({ messages, setMessages, resetSession, useOldSession }) => (
				<>
					<Modal show={help}>
						<Modal.Header closeButton style={{ backgroundColor: '#305cc5', color: '#fff' }}>
							<Modal.Title>{translations.Last_Question}</Modal.Title>
						</Modal.Header>
						<Modal.Body style={{ backgroundColor: 'inherit' }} dangerouslySetInnerHTML={{ __html: `<p>${help}</p>` }}></Modal.Body>
						<Modal.Footer>
							<Button className="btn btn-primary text-white" onClick={() => setHelp(false)}>
								{translations.close}
							</Button>
						</Modal.Footer>
					</Modal>
					<Modal show={selectedUser !== null}>
						<Modal.Header closeButton>
							<Modal.Title>{translations.Update_User}</Modal.Title>
						</Modal.Header>
						<Modal.Body style={{ backgroundColor: 'inherit' }} >
							<div className="form-group">
								{/*<label>{translations.First_Name}</label>
								<input type="text" defaultValue={selectedUser !== null ? selectedUser.FirstName : ''} onChange={(e) => { changeSelectedUser(e.target.value, 'FirstName') }} className="form-control" />
								<br />
								<label>{translations.Last_Name}</label>
								<input type="text" defaultValue={selectedUser !== null ? selectedUser.LastName : ''} onChange={(e) => { changeSelectedUser(e.target.value, 'LastName') }} className="form-control" />
								<br />*/}

								<label>{translations.fileMatter}</label>
								<input type="text" defaultValue={selectedUser !== null ? selectedUser.fileMatter : ''} onChange={(e) => { changeSelectedUser(e.target.value, 'fileMatter') }} className="form-control" />
								<br/>
								<label>{translations.Full_Name}</label>
								<input type="text" defaultValue={selectedUser !== null ? selectedUser.FirstName : ''} onChange={(e) => { changeSelectedUser(e.target.value, 'FirstName') }} className="form-control" />
								<br />
								<label>{translations.Email}</label>
								<input type="text" disabled defaultValue={selectedUser !== null ? selectedUser.Email : ''}  className="form-control" placeholder="Email" /> 
								{/*onChange={(e) => { changeSelectedUser(e.target.value, 'Email') }}*/}
								{/*<span style={{ color: 'red', fontSize: 12 }}>{emailError}</span>*/}
								<br />
								<label>{translations.Phone_number}</label>
								<input type="number" defaultValue={selectedUser !== null ? selectedUser.phone : ''} onChange={(e) => { changeSelectedUser(e.target.value, 'phone') }} className="form-control" />
								<br />
								<label>{translations.Address}</label>
								<input type="text" defaultValue={selectedUser !== null ? selectedUser.address : ''} onChange={(e) => { changeSelectedUser(e.target.value, 'address') }} className="form-control" />
								<br />
								<label>{translations.Language}</label>
								<select defaultValue={selectedUser !== null ? selectedUser.language : 'en'} onChange={(e) => { changeSelectedUser(e.target.value, 'language') }} className="form-control">
					            	<option value="en">English</option>
					            	<option value="es">Spanish</option>
					          	</select>
					          	<br />
								<label>{translations.Photo}</label>
								<input
						          	type='file'
						            className="form-control"
						            accept= 'image/*'
						            onChange={e => {
						            	setFileObject((e.target as HTMLInputElement).files[0]);
						            }}
					          	/>
							  	<img src={selectedUser !== null ? selectedUser.photo : ''} style={{width: '20%', float:'right', position: 'relative', top: '-55px', display: selectedUser !== null && selectedUser.photo != '' ? 'inherit' : 'none'}}/>
							</div>
						</Modal.Body>
						<Modal.Footer>
							<Button className="btn btn-primary" onClick={() => updateUser()}>
								{translations.Submit}
							</Button>
							<Button className="btn btn-danger" onClick={() => { setSelectedUser(null); setemailError(null); }}>
								{translations.close}
							</Button>
						</Modal.Footer>
					</Modal>
					<Modal show={addUser == true}>
						<Modal.Header closeButton>
							<Modal.Title>{translations.Add_User}</Modal.Title>
						</Modal.Header>
						<Modal.Body style={{ backgroundColor: 'inherit' }} >
							<div className="alert alert-danger" style={{"display": addError != null ? 'block' : 'none'}}>{addError}</div>
							<div className="form-group">
								<label>{translations.fileMatter}</label>
								<input type="text"  onChange={(e) => { changeAddUser(e.target.value, 'fileMatter') }} className="form-control" />
								<br/>
								<label>{translations.Full_Name}</label>
								<input type="text"  onChange={(e) => { changeAddUser(e.target.value, 'FirstName') }} className="form-control" />
								<br />
								<label>{translations.Email}</label>
								<input type="text"   className="form-control" placeholder="Email" onChange={(e) => { changeAddUser(e.target.value, 'Email') }} /> 
								<span style={{ color: 'red', fontSize: 12 }}>{emailError}</span>
								<br />
								<label>{translations.Phone_number}</label>
								<input type="number"  onChange={(e) => { changeAddUser(e.target.value, 'phone') }} className="form-control" />
								<br />
								<label>{translations.Address}</label>
								<input type="text"  onChange={(e) => { changeAddUser(e.target.value, 'address') }} className="form-control" />
								<br />
								<label>{translations.Language}</label>
								<select onChange={(e) => { changeAddUser(e.target.value, 'language') }} className="form-control">
					            	<option value="en">English</option>
					            	<option value="es">Spanish</option>
					          	</select>
					          	<br />
								<label>{translations.Photo}</label>
								<input
						          	type='file'
						            className="form-control"
						            accept= 'image/*'
						            onChange={e => {
						            	setPhotoObject((e.target as HTMLInputElement).files[0]);
						            }}
					          	/>
							</div>
						</Modal.Body>
						<Modal.Footer>
							<Button className="btn btn-primary" onClick={() => {saveUser()}}>
								{translations.Submit}
							</Button>
							<Button className="btn btn-danger" onClick={() => { setAddUser(false); setUserData(null); setemailError(null); setAddError(null);}}>
								{translations.close}
							</Button>
						</Modal.Footer>
					</Modal>
					<div>
						{loading ? <div className="loader-cont"><div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div> : null}
						<Header resetSession={resetSession} />
						<div className="app-main">
							<div className="app-main-inner mrt-40">
								<Container
									style={{
										paddingTop: 30,
										paddingBottom: 30,
									}}
								>	
									<div className="table-responsive userlist_">
										<div className="loadnextInterview">
											<span className="desktop-view">
												{active !== 0 && !loading && availInterviews.length > 0 ? <span onClick={() => backInterview()} className="material-icons">
													<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect x="0.5" y="0.5" width="20" height="20" rx="10" fill="white" stroke="#555555" />
														<path fill-rule="evenodd" clip-rule="evenodd" d="M10.9917 6.19651C11.2537 5.9345 11.6785 5.9345 11.9405 6.19651C12.2025 6.45853 12.2025 6.88333 11.9405 7.14535L8.64333 10.4425L12.0554 13.8547C12.3175 14.1167 12.3175 14.5415 12.0554 14.8035C11.7934 15.0655 11.3686 15.0655 11.1066 14.8035L7.36866 11.0656C7.30652 11.0342 7.24824 10.9926 7.19634 10.9407C6.93433 10.6787 6.93433 10.2539 7.19634 9.99186L10.9917 6.19651Z" fill="#555555" />
													</svg>
												</span> : null}
												{availInterviews.length > 0 && !loading && active < allavailInterviews.length - 2 ? <span onClick={() => nextInterview()} className="material-icons">
													<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect x="0.5" y="0.5" width="20" height="20" rx="10" fill="white" stroke="#555555" />
														<path fill-rule="evenodd" clip-rule="evenodd" d="M9.26026 6.19651C8.99825 5.9345 8.57344 5.9345 8.31142 6.19651C8.04941 6.45853 8.04941 6.88333 8.31142 7.14535L11.6086 10.4425L8.19651 13.8547C7.9345 14.1167 7.9345 14.5415 8.19651 14.8035C8.45853 15.0655 8.88333 15.0655 9.14535 14.8035L12.8833 11.0656C12.9454 11.0342 13.0037 10.9926 13.0556 10.9407C13.3176 10.6787 13.3176 10.2539 13.0556 9.99186L9.26026 6.19651Z" fill="#555555" />
													</svg>
												</span> : null}
											</span>
										</div>
										<table className="table table-bordered awsUser">
											<span className="mobile-view">
												{
													users.length == 0
														? '' :
														<thead>
															<th className="removeBorderRight ">{translations.user_by_email}

																{/*<Button className="btn btn-primary pull-right" onClick={() => usersSortByLastActivity(allInterviews, users)}>
																	Sort by Last Activity	
																</Button>*/}
															</th>
															<th className="header_title_mb">
																{active !== 0 && !loading && availInterviews.length > 0 ? <span onClick={() => backInterview()} className="material-icons">
																	<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																		<rect x="0.5" y="0.5" width="20" height="20" rx="10" fill="white" stroke="#555555" />
																		<path fill-rule="evenodd" clip-rule="evenodd" d="M10.9917 6.19651C11.2537 5.9345 11.6785 5.9345 11.9405 6.19651C12.2025 6.45853 12.2025 6.88333 11.9405 7.14535L8.64333 10.4425L12.0554 13.8547C12.3175 14.1167 12.3175 14.5415 12.0554 14.8035C11.7934 15.0655 11.3686 15.0655 11.1066 14.8035L7.36866 11.0656C7.30652 11.0342 7.24824 10.9926 7.19634 10.9407C6.93433 10.6787 6.93433 10.2539 7.19634 9.99186L10.9917 6.19651Z" fill="#555555" />
																	</svg>
																</span> : <span className="material-icons disable_svg">
																		<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<rect x="0.5" y="0.5" width="20" height="20" rx="10" fill="white" stroke="#555555" />
																			<path fill-rule="evenodd" clip-rule="evenodd" d="M10.9917 6.19651C11.2537 5.9345 11.6785 5.9345 11.9405 6.19651C12.2025 6.45853 12.2025 6.88333 11.9405 7.14535L8.64333 10.4425L12.0554 13.8547C12.3175 14.1167 12.3175 14.5415 12.0554 14.8035C11.7934 15.0655 11.3686 15.0655 11.1066 14.8035L7.36866 11.0656C7.30652 11.0342 7.24824 10.9926 7.19634 10.9407C6.93433 10.6787 6.93433 10.2539 7.19634 9.99186L10.9917 6.19651Z" fill="#555555" />
																		</svg>
																	</span>}

																{availInterviews.length != 0 ? availInterviews.map(function (result, index) {
																	return (
																		<span>{result.title}</span>
																	);
																})
																	: ''
																}
																{availInterviews.length > 0 && !loading && active < allavailInterviews.length - 1 ? <span onClick={() => nextInterview()} className="material-icons">
																	<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																		<rect x="0.5" y="0.5" width="20" height="20" rx="10" fill="white" stroke="#555555" />
																		<path fill-rule="evenodd" clip-rule="evenodd" d="M9.26026 6.19651C8.99825 5.9345 8.57344 5.9345 8.31142 6.19651C8.04941 6.45853 8.04941 6.88333 8.31142 7.14535L11.6086 10.4425L8.19651 13.8547C7.9345 14.1167 7.9345 14.5415 8.19651 14.8035C8.45853 15.0655 8.88333 15.0655 9.14535 14.8035L12.8833 11.0656C12.9454 11.0342 13.0037 10.9926 13.0556 10.9407C13.3176 10.6787 13.3176 10.2539 13.0556 9.99186L9.26026 6.19651Z" fill="#555555" />
																	</svg>
																</span> : <span className="material-icons disable_svg">
																		<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<rect x="0.5" y="0.5" width="20" height="20" rx="10" fill="white" stroke="#555555" />
																			<path fill-rule="evenodd" clip-rule="evenodd" d="M9.26026 6.19651C8.99825 5.9345 8.57344 5.9345 8.31142 6.19651C8.04941 6.45853 8.04941 6.88333 8.31142 7.14535L11.6086 10.4425L8.19651 13.8547C7.9345 14.1167 7.9345 14.5415 8.19651 14.8035C8.45853 15.0655 8.88333 15.0655 9.14535 14.8035L12.8833 11.0656C12.9454 11.0342 13.0037 10.9926 13.0556 10.9407C13.3176 10.6787 13.3176 10.2539 13.0556 9.99186L9.26026 6.19651Z" fill="#555555" />
																		</svg>
																	</span>}
															</th>
														</thead>
												}
											</span>
											<span className="desktop-view">
												{
													users.length == 0
														? '' :
														<thead>
															<tr>
																<th className="removeBorderRight">
																	<div className="d-flex">{translations.users} 
																		<span className="material-icons text-primary ml-1" onClick={() => setAddUser(true)} style={{"cursor": "pointer"}}>add_circle</span>
																	</div>
																</th>
																<th className="whitespace">
																{/*<Button className="btn btn-primary pull-right" onClick={() => usersSortByLastActivity(allInterviews, users)}>
																	Sort by Last Activity	
																</Button>*/}

																	<div className="pull-right">
																		<select className="form-control"  onChange={(e) => usersFilterStatus(e,users)}>
																			<option value="all">All Users</option>
																			<option value="active">Active Users</option>
																			<option value="inactive">Inactive Users</option>
																		</select>
																	</div>
																</th>
																<th>
																	Last LoggedIn
																</th>
																{availInterviews.length != 0
																	?
																	availInterviews.map(function (result, index) {
																		return (
																			<th className="text-center p-0">
																				<div className="interviewResult"><div>{result.title}</div>
																					<table className="w-100">
																						<tr>
																							<td className="border-left-0 border-right-0 border-bottom-0">{translations.Done}</td>
																							<td className="white-space border-left-0 border-right-0 border-bottom-0">{translations.Last_Question}</td>
																							<td className="border-left-0 border-right-0 border-bottom-0" style={{ opacity: 0 }}>{translations.view}</td>
																							<td className="border-left-0 border-right-0 border-bottom-0" style={{ opacity: 0 }}>{translations.Down}</td>
																						</tr>
																					</table>
																				</div>
																			</th>
																		);
																	})
																	: ''
																}

															</tr>
														</thead>
												}
											</span>
											<tbody>
												{
													users.length == 0
														? loading ? null : <h4>{translations.no_r_users}</h4>
														: users.map(function (result, index) {
															let userCompletedInterviews: any = allInterviews.filter(iData => {
																return iData.userId == result.Email;
															});
															return (
																<tr key={index}>
																	<td className="emailSection">
																		<div className="emailId d-flex flex-wrap align-items-center">
																			{
																				result.Status == "CONFIRMED" ?
																					<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderVerifiedTooltip}>
																						<span className="material-icons">check_circle</span>
																					</OverlayTrigger>
																					: (result.Status == "RESET_REQUIRED" ?
																						<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderResetRequiredTooltip}>
																						<span className="text-warning material-icons">warning</span>
																					</OverlayTrigger>
																					:
																					<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderNotVerifiedTooltip}>
																						<span className="text-danger material-icons">error</span>
																					</OverlayTrigger>
																			)}
																			<div className="emailIds">
																				<span style={{'display': result.fileMatter? 'inline' : 'none'}}>{result.fileMatter}&nbsp;  - &nbsp;</span>
																				<span>{result.FirstName}</span>
																				&nbsp;{
																					userCognitoGroups.indexOf('Superadmin') != -1 ? getBadge(result) : null
																				}
																				<br/>
																				{result.Email}
																				<span className="mobile-view"> <br/>
																				{result.lastLogin ? 'Last LoggedIn: '+result.lastLogin : ''} </span>
																			</div>
																			
																		</div>
																	</td>

																	<td className="emailStatus">
																		<div className="p-0 d-flex flex-wrap align-items-center justify-content-end">

																			<OverlayTrigger
																				trigger="focus"
																				key={index}
																				placement={'bottom'}
																				overlay={
																					<Popover id={`popover-positioned-${index}`}>
																						<Popover.Title as="h3">{`Popover ${index}`}</Popover.Title>
																						<Popover.Content>
																							{userCognitoGroups.indexOf('Superadmin') != -1 && !result.Self ?
																								<span
																									onClick={() => disableUser(result)}
																									className="text-danger">{translations.delete}</span> : null
																							}
																							{userCognitoGroups.indexOf('Superadmin') != -1 ?
																								<span
																									onClick={() => setSelectedUser(result)}
																									className="text">{translations.edit}</span> : null
																							}
																							{userCognitoGroups.indexOf('Superadmin') != -1 && result.Status == "UNCONFIRMED"?
																								<span
																									onClick={() => confirmUser(result)}
																									className="text">{translations.confirm}</span> : null
																							}
																							{userCognitoGroups.indexOf('Superadmin') != -1 && result.Status == "RESET_REQUIRED"?
																								<span
																									onClick={() => resetInformUser(result)}
																									className="text">{translations.Ask_for_reset}</span> : null
																							}
																							{
																								userCognitoGroups.indexOf('Superadmin') != -1 && !result.Self && result.Status == "CONFIRMED" && !checkInSuperAdmin(result) ?
																									checkInAdmin(result) ? <span
																										onClick={() => removeAsAdmin(result)}
																										className="text-danger">{translations.Remove_as_Admin}</span> :
																										<span
																											onClick={() => createAdmin(result)}
																											className="text-secondry">{translations.Make_Admin}</span> : null
																							}
																							{userCognitoGroups.indexOf('Superadmin') != -1 && Config.appHost == "lawdroid"?
																								<span
																									onClick={() => completeInterview(result)}
																									className="text">Complete Interview</span> : null
																							}
																						</Popover.Content>
																					</Popover>
																				}
																			>
																				<Button>
																					<svg width="16" height="5" viewBox="0 0 16 5" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<rect y="0.5" width="4" height="4" rx="2" fill="#555555" />
																						<rect x="6" y="0.5" width="4" height="4" rx="2" fill="#555555" />
																						<rect x="12" y="0.5" width="4" height="4" rx="2" fill="#555555" />
																					</svg>
																				</Button>
																			</OverlayTrigger>

																		</div>
																	</td>
																	<td className = "desktop-view-block-revert emailStatus">
																		{result.lastLogin} <br/>
																		{result.IP} &nbsp;&nbsp; {result.Browser}	
																	</td>
																	{availInterviews.length != 0
																		?
																		availInterviews.map(function (avail_iData, index) {
																			let userInterview: any = '';
																			let percent: any = 0;
																			let lastquestion = '';
																			let lastquestionFull = '';
																			if (userCompletedInterviews.length > 0) {
																				userInterview = userCompletedInterviews.filter(iData => {
																					if (InterviewRef.languagesconfigs[avail_iData.filename]) {
																						let files = InterviewRef.languagesconfigs[avail_iData.filename];
																						files = Object.keys(files).map((key) => files[key]);
																						return files.indexOf(iData.i) > -1;
																					}
																					return true;
																				});
																				if (userInterview != undefined && userInterview.length > 0) {
																					userInterview = userInterview[0];
																					let countInt: any = availInterviews.filter(c => {
																						if (InterviewRef.languagesconfigs[userInterview.i]) {
																							let files = InterviewRef.languagesconfigs[userInterview.i];
																							files = Object.keys(files).map((key) => files[key]);
																							return files.indexOf(c.filename) > -1;
																						}
																						return true;
																					});
																					if (countInt != undefined && countInt.length > 0) {
																						countInt = countInt[0];
																						if (countInt.metadata.count && userInterview.questionAns) {
																							countInt = countInt.metadata.count;
																							let doneQuestions = userInterview.questionAns.length;
																							percent = (doneQuestions * 100) / countInt;
																							lastquestion = userInterview.questionAns[userInterview.questionAns.length - 1].questionName;
																							lastquestionFull = userInterview.questionAns[userInterview.questionAns.length - 1].variable.questionText;
																						}
																					}
																				}
																			}

																			return (
																				<td className="text-center">
																					<table className="w-100 interviewsAdded">
																						<tr>
																							<td className="border-left-0 border-right-0 border-bottom-0">
																								{
																									userInterview != undefined && userInterview != '' ?

																										<span><em className="d-block d-sm-none">Done</em>
																											{(checkFileNumber(userInterview) || parseInt(percent) > 100) ? '100' : parseInt(percent)}%
		</span>
																										: '-'
																								}
																							</td>
																							<td className="border-left-0 border-right-0 border-bottom-0">
																								{
																									userInterview != undefined && userInterview != '' ?

																										<span><em className="d-block d-sm-none">{translations.Last_Question}</em>
																											<a href="javascript:void(0)" className="mr-2 text-info" onClick={() => setHelp(lastquestionFull)}>{lastquestion.replace("Question_", "")}</a>
																										</span>
																										: '-'
																								}
																							</td>
																							<td className="border-left-0 border-right-0 border-bottom-0">
																								{
																									userInterview != undefined && userInterview != '' ?
																										<span><em className="d-block d-sm-none">&nbsp;</em>
																											<a title={translations.View_Interview} className="text-info" onClick={() => viewInterview(userInterview)}>
																												<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
																													<path d="M5.75781 19.2188C5.75781 19.6503 5.40808 20 4.97656 20H3.17969C1.45651 20 0.0546875 18.5982 0.0546875 16.875V3.125C0.0546875 1.40182 1.45651 0 3.17969 0H12.7848C14.5078 0 15.9098 1.40182 15.9098 3.125V7.77344C15.9098 8.20496 15.5599 8.55469 15.1285 8.55469C14.697 8.55469 14.3473 8.20496 14.3473 7.77344V3.125C14.3473 2.26349 13.6463 1.5625 12.7848 1.5625H3.17969C2.31818 1.5625 1.61719 2.26349 1.61719 3.125V16.875C1.61719 17.7365 2.31818 18.4375 3.17969 18.4375H4.97656C5.40808 18.4375 5.75781 18.7872 5.75781 19.2188ZM12.7846 5.46875C12.7846 5.03723 12.4349 4.6875 12.0034 4.6875H3.95651C3.52515 4.6875 3.17526 5.03723 3.17526 5.46875C3.17526 5.90027 3.52515 6.25 3.95651 6.25H12.0034C12.4349 6.25 12.7846 5.90027 12.7846 5.46875ZM9.66406 8.59375C9.66406 8.16223 9.31433 7.8125 8.88281 7.8125H3.95651C3.52515 7.8125 3.17526 8.16223 3.17526 8.59375C3.17526 9.02527 3.52515 9.375 3.95651 9.375H8.88281C9.31433 9.375 9.66406 9.02527 9.66406 8.59375ZM3.95651 10.9375C3.52515 10.9375 3.17526 11.2872 3.17526 11.7188C3.17526 12.1503 3.52515 12.5 3.95651 12.5H7.20312C7.63464 12.5 7.98437 12.1503 7.98437 11.7188C7.98437 11.2872 7.63464 10.9375 7.20312 10.9375H3.95651ZM17.5863 19.4188C17.2857 19.7882 16.8421 20 16.3692 20H8.74014C8.26468 20 7.81973 19.7884 7.51944 19.4194C7.21732 19.0482 7.09998 18.5658 7.19748 18.0962C7.44986 16.8803 8.11835 15.7741 9.07965 14.9811C9.44372 14.6808 9.84381 14.4308 10.268 14.2355C9.79529 13.6986 9.50781 12.995 9.50781 12.2252C9.50781 10.545 10.8745 9.17831 12.5547 9.17831C14.2348 9.17831 15.6016 10.545 15.6016 12.2252C15.6016 12.995 15.3141 13.6986 14.8414 14.2355C15.2656 14.4308 15.6656 14.6806 16.0297 14.9811C16.9718 15.7582 17.6325 16.8362 17.8962 18.0232C17.9023 18.0438 17.9075 18.0646 17.9119 18.0858C18.0099 18.5582 17.8911 19.044 17.5863 19.4188ZM11.0703 12.2252C11.0703 13.0437 11.7362 13.7096 12.5547 13.7096C13.3732 13.7096 14.0391 13.0437 14.0391 12.2252C14.0391 11.4067 13.3732 10.7408 12.5547 10.7408C11.7362 10.7408 11.0703 11.4067 11.0703 12.2252ZM16.3824 18.4154C16.3822 18.4149 16.382 18.4143 16.382 18.4138C16.0068 16.6071 14.3972 15.2956 12.5547 15.2956C10.7122 15.2956 9.10239 16.6071 8.72732 18.4138C8.72381 18.4314 8.73587 18.437 8.73587 18.4372C8.73617 18.4372 8.73755 18.4375 8.74014 18.4375H16.3692C16.3697 18.437 16.3802 18.4291 16.3824 18.4154Z" fill="#555555" />
																												</svg>
																											</a>
																										</span>
																										: ''
																								}
																							</td>
																							<td className="border-left-0 border-right-0 border-bottom-0">
																								{
																									userInterview != undefined && userInterview != '' ?
																										<span><em className="d-block d-sm-none">&nbsp;</em>
																											{checkFileNumber(userInterview) ?
																												<span>
																													<a target="_blank" title={translations.download_interview_pdf} className=" text-success " onClick={() => downloadFile(userInterview.fileNumber, userInterview.title)} >
																														<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
																															<path fill-rule="evenodd" clip-rule="evenodd" d="M8.08504 14.4042C8.24029 14.7551 8.59155 15 9 15C9.37077 15 9.69442 14.7982 9.8671 14.4985C9.95874 14.4519 10.0447 14.3903 10.1213 14.3137L14.1962 10.2388C14.5868 9.84826 14.5868 9.2151 14.1962 8.82457C13.8057 8.43405 13.1725 8.43405 12.782 8.82457L10 11.6066L10 1C10 0.447715 9.55228 0 9 0C8.44771 0 8 0.447715 8 1L8 11.5858L5.1213 8.70711C4.73077 8.31659 4.09761 8.31659 3.70708 8.70711C3.31656 9.09764 3.31656 9.7308 3.70708 10.1213L7.782 14.1962C7.87209 14.2863 7.97508 14.3556 8.08504 14.4042ZM1 18C0.447715 18 0 18.4477 0 19C0 19.5523 0.447716 20 1 20H17C17.5523 20 18 19.5523 18 19C18 18.4477 17.5523 18 17 18H1Z" fill="#3A8FBF" />
																														</svg>

																													</a></span>
																												: ''}
																										</span>
																										: ''
																								}
																							</td>
																						</tr>
																					</table>
																				</td>
																			);
																		})
																		: ''
																	}
																</tr>
															);
														})
												}
											</tbody>
										</table>
									</div>
								</Container>
							</div>
						</div>
						<Footer />
					</div>
				</>
			)}
		/>
	);
};